import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import {
  getColorCodeForGivenCategory,
  getBoldLabelText,
  getNormalLabelText,
} from '../../../util/Insight360Utils';
import { MEDIA_ICON_LIST } from '../../../constants';
import * as insight360Actions from '../../../actions/insight360Actions';

const getImageIcon = imageKey => {
  let selectedIcon;
  const imageComponent = _.find(MEDIA_ICON_LIST, { id: imageKey });
  if (imageComponent !== undefined) {
    selectedIcon = imageComponent.selectedIcon;
  }
  return selectedIcon;
};

class MediaSinglePersonaDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderDeepDiveSlider = (value, deepDivePersonaObject) => {
    this.props.insight360Actions.showDeepDivePopup(value, deepDivePersonaObject);
  }

  render() {
    const { brandsDetail,
      personaIndex,
      selectedIcon,
      highestIndex,
      categoryName,
      selectedTab,
    } = this.props;
    let widthPercent = 0;
    const mediaBrandDetails = brandsDetail;
    const mediaBrandCategoryName = mediaBrandDetails.brandCategory;
    const mediaBrandLabel = mediaBrandDetails.brandLabel;
    const mediaLabelBold = getBoldLabelText(mediaBrandLabel);
    const mediaLabelNormal = getNormalLabelText(mediaBrandLabel);
    const mediaIndex = mediaBrandDetails.index;
    const mediaReach = mediaBrandDetails.pct;
    widthPercent = `${_.round((mediaIndex * 100) / highestIndex)}%`;
    // const selectedTabVal = selectedTab;
    const deepDivePersonaObject = {
      personaIndex,
      category: mediaBrandDetails.brandSubCategory,
      section: 'Media',
      selectedTab,
    };
    return (
      <div>
        {brandsDetail !== undefined && (
          <div className="attitude-detail-grid">
            <div className="attitude-comparision-float" id="mediaSingle">
              <div className="attitude-float">
                <div className="attitude-image-border attitude-float">
                  {getImageIcon(selectedIcon) === undefined && (
                    <div className="imageblock" />
                  )}
                  {getImageIcon(selectedIcon) !== undefined && (
                    <img
                      onClick={() => this.renderDeepDiveSlider(true, deepDivePersonaObject)}
                      className="i360-demo-comparision-img pointer-cursor"
                      src={getImageIcon(selectedIcon)}
                      alt={categoryName}
                    />
                  )}
                  <div className="attitude-comparision-icon-labels pointer-cursor"
                    onClick={() => this.renderDeepDiveSlider(true, deepDivePersonaObject)}
                  >
                    {mediaBrandCategoryName}
                  </div>
                </div>
              </div>

              <div className="attitude-comparision-metrics attitude-float pointer-cursor"
                onClick={() => this.renderDeepDiveSlider(true, deepDivePersonaObject)}
              >
                <div>INDEX:&nbsp;&nbsp;{mediaIndex}</div>
                <div>REACH:&nbsp;&nbsp;{mediaReach} </div>
              </div>

              <div className="attitude-comparision-statement-float">
                <div className="large-12 medium-12 small-12 columns">
                  <div
                    onClick={() => this.renderDeepDiveSlider(true, deepDivePersonaObject)}
                    className="attitude-status-bar pointer-cursor"
                    style={{
                      width: widthPercent,
                      backgroundColor: getColorCodeForGivenCategory(
                        mediaBrandDetails.iconCategory,
                        this.props.insight360studyInfo.ss,
                      ),
                    }}
                  />
                  <div
                    className="media-comparision-data insight360-attitude-align pointer-cursor"
                    onClick={() => this.renderDeepDiveSlider(true, deepDivePersonaObject)}
                    title={mediaBrandLabel}
                  >
                    <span style={{ fontWeight: 'bold' }}>{mediaLabelBold}</span>
                    <span>{mediaLabelNormal}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

MediaSinglePersonaDetail.propTypes = {
  brandsDetail: PropTypes.shape({}),
  selectedIcon: PropTypes.string,
  highestIndex: PropTypes.number,
  categoryName: PropTypes.string,
  insight360studyInfo: PropTypes.shape({
    ss: PropTypes.string,
  }),
  personaIndex: PropTypes.number,
  selectedTab: PropTypes.string,
  insight360Actions: PropTypes.shape({
    showDeepDivePopup: PropTypes.func,
  }),
};


function mapDispatchToProps(dispatch) {
  return {
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
  };
}


export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(MediaSinglePersonaDetail);
